<template>
    <div class="department-permission-row-wrapper">
        <!-- Departman ana satırı -->
        <div 
            class="department-permission-row" 
            :class="{ 
                'row-odd': isOdd, 
                'inactive': !isActive,
                'blur-row': !isActive 
            }"
        >
            <div class="target-cell">
                <div class="target-info">
                    <SupsisButton 
                        ghost 
                        small 
                        @click.stop="toggleExpanded"
                        class="collapse-toggle"
                    >
                        <i class="material-icons">
                            {{ isExpanded ? 'expand_less' : 'expand_more' }}
                        </i>
                    </SupsisButton>
                    <i class="material-icons">group</i>
                    <span class="target-name">{{ departmentName }}</span>
                    <span class="user-count">({{ departmentUsers.length }})</span>
                </div>
                <SupsisButton 
                    v-if="!isActive"
                    ghost 
                    primary
                    icon="add" 
                    small 
                    @click="$emit('activate', department._id)"
                    v-tippy="{ content: 'Yetki Ver' }"
                />
                <SupsisButton 
                    v-else
                    ghost 
                    danger 
                    icon="remove_circle" 
                    small 
                    @click="$emit('deactivate', department._id)"
                    v-tippy="{ content: 'Yetkiyi Kaldır' }"
                />
            </div>

            <div 
                v-for="group in scopeGroups" 
                :key="group.id" 
                class="scope-group-cell"
            >
                <div class="scope-toggles">
                    <div 
                        v-for="scope in group.scopes" 
                        :key="scope"
                        class="scope-toggle-cell"
                        @click="isActive && toggleScope(scope)"
                    >
                        <SupsisButton 
                            :class="{ 'scope-active': hasScope(scope) }"
                            :disabled="!isActive"
                        >
                            <i class="material-icons" v-if="hasScope(scope)">done</i>
                            <div 
                                v-else 
                                class="disabled-item"
                                @mouseenter="isActive && hoverEffect($event, true)"
                                @mouseleave="isActive && hoverEffect($event, false)"
                            >
                                <i class="material-icons">done</i>
                                <i class="material-icons">circle</i>
                            </div>
                        </SupsisButton>
                    </div>
                </div>
            </div>
        </div>

        <!-- Department users (accordion body) -->
        <div v-if="isExpanded && departmentUsers.length > 0" class="department-users">
            <DepartmentUserRow
                v-for="(user, index) in departmentUsers"
                :key="`dept-user-${user._id}`"
                :user="user"
                :department-scopes="target ? target.scopes : []"
                :user-target="getUserTarget(user)"
                :scope-groups="scopeGroups"
                :is-department-active="isActive"
            />
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";
import DepartmentUserRow from "./DepartmentUserRow.vue";

export default Vue.extend({
    name: "DepartmentPermissionRow",
    components: {
        SupsisButton,
        DepartmentUserRow,
    },
    props: {
        department: {
            type: Object,
            required: true,
        },
        target: {
            type: Object,
            default: null,
        },
        targetIndex: {
            type: Number,
            default: -1,
        },
        scopeGroups: {
            type: Array,
            required: true,
        },
        users: {
            type: Array,
            required: true,
        },
        permissionTargets: {
            type: Array,
            required: true,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        isOdd: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isExpanded: true, // Default olarak açık
        };
    },
    computed: {
        departmentName() {
            const lang = this.$i18n.locale;
            return this.department.languageContent && this.department.languageContent[lang]
                ? this.department.languageContent[lang].name
                : this.department.name || this.$t("tables.permissions.unknownDepartment");
        },
        departmentUsers() {
            // Bu departmana ait kullanıcıları bul
            const deptUsers = this.users.filter((user) => {
                const userSubjects = user.subjects || [];
                
                // Eğer kullanıcının subjects array'i boşsa veya null/undefined ise,
                // bu kullanıcı TÜM departmanlara sahiptir
                if (!userSubjects || userSubjects.length === 0) {
                    return true;
                }
                
                // Yoksa subjects array'inde bu departman var mı kontrol et
                const hasThisDept = userSubjects.some((subj) => {
                    const subjId = typeof subj === "object" ? subj._id : subj;
                    return subjId && subjId.toString() === this.department._id.toString();
                });
                return hasThisDept;
            });
            
            console.log(`Departman "${this.departmentName}" kullanıcıları:`, deptUsers.length, deptUsers.map(u => u.name));
            return deptUsers;
        },
    },
    methods: {
        hasScope(scope) {
            if (!this.isActive || !this.target) return false;
            return (this.target.scopes || []).includes(scope);
        },
        toggleScope(scope) {
            if (!this.isActive) return;
            this.$emit("toggle-scope", { targetIndex: this.targetIndex, scope });
        },
        hoverEffect(e, hover) {
            e.target.classList[hover ? "add" : "remove"]("active");
        },
        toggleExpanded() {
            this.isExpanded = !this.isExpanded;
        },
        getUserTarget(user) {
            return this.permissionTargets.find(
                (t) => t.target === "user" && t.user && t.user.toString() === user._id.toString()
            );
        },
    },
});
</script>

<style scoped lang="scss">
.department-permission-row-wrapper {
    .department-permission-row {
        display: flex;
        border-bottom: 1px solid var(--color-border-default);
        min-height: 50px;
        transition: all 0.3s ease;

        &.row-odd {
            background: var(--color-bg-neutral-default);
        }

        &.inactive {
            opacity: 0.5;
            
            &.blur-row {
                filter: blur(0.5px);
            }
        }

        &:hover {
            background: var(--color-bg-neutral-hover);
            
            &.inactive {
                opacity: 0.8;
                filter: blur(0);
            }
        }

        .target-cell {
            width: 250px;
            min-width: 250px;
            flex-shrink: 0;
            padding: 8px 12px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-right: 1px solid var(--color-border-default);

            .target-info {
                display: flex;
                align-items: center;
                gap: 8px;
                flex: 1;
                min-width: 0;

                .collapse-toggle {
                    padding: 4px !important;
                    min-width: 28px !important;
                    height: 28px !important;

                    .material-icons {
                        font-size: 18px;
                    }
                }

                .material-icons {
                    font-size: 18px;
                    color: var(--color-icon-default);
                    flex-shrink: 0;
                }

                .target-name {
                    font-weight: 500;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .user-count {
                    font-size: 12px;
                    color: var(--color-text-subdued);
                }
            }
        }

        .scope-group-cell {
            flex: 1;
            display: flex;
            border-right: 1px solid var(--color-border-default);

            &:last-child {
                border-right: none;
            }

            .scope-toggles {
                display: flex;
                width: 100%;

                .scope-toggle-cell {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-right: 1px solid var(--color-border-subdued);
                    cursor: pointer;
                    padding: 0;

                    &:last-child {
                        border-right: none;
                    }

                    &:hover {
                        background: var(--color-bg-primary-subdued-hover);
                    }

                    .supsis-button {
                        width: 100%;
                        height: 100%;
                        min-height: 50px;
                        border: none;
                        background: transparent;
                        padding: 0;

                        &.scope-active {
                            .material-icons {
                                color: var(--color-icon-success);
                            }
                        }

                        .disabled-item {
                            :first-child {
                                display: none;
                            }

                            &.active {
                                :first-child {
                                    display: block;
                                }
                                :last-child {
                                    display: none;
                                }
                            }
                        }

                        .material-icons {
                            font-size: 20px;
                        }
                    }
                }
            }
        }
    }

    .department-users {
        background: #f9f9f9;
        border-bottom: 2px solid var(--color-border-default);
    }
}
</style>

